import type {MessageDescriptor} from 'react-intl';
import type {RtcErrorCode} from '@phonehq/rtc-core';
import {groupCallMessages as m} from '../messages';
import type {GroupCallNotice} from '../services/groupCallOrchestrator';

export const noticeMessage = (notice: GroupCallNotice): MessageDescriptor => {
    switch (notice) {
        case 'power_levels_forbidden':
            return m.noticePowerLevels;
        case 'power_levels_failed':
            return m.noticePowerLevelsFailed;
        case 'busy':
            return m.noticeBusy;
        case 'not_owner':
            return m.noticeNotOwner;
        case 'disabled':
            return m.noticeDisabled;
        case 'no_session':
            return m.noticeNoSession;
    }
};

export const errorMessage = (code: RtcErrorCode | undefined): MessageDescriptor => {
    switch (code) {
        case 'forbidden':
        case 'unauthorized':
            return m.errorForbidden;
        case 'not_encrypted':
            return m.errorNotEncrypted;
        case 'call_full':
            return m.errorFull;
        case 'unavailable':
            return m.errorUnavailable;
        case 'media_failed':
            return m.errorMedia;
        case 'network':
            return m.errorNetwork;
        case 'webrtc_blocked':
            return m.errorWebrtcBlocked;
        case 'rate_limited':
            return m.errorRateLimited;
        default:
            return m.errorGeneric;
    }
};
